import React from "react"

const ExclamationIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_658_11775)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2163 9.00001C17.2163 12.5757 14.098 15.6177 10.0692 15.6177C6.0404 15.6177 2.92216 12.5757 2.92216 9.00001C2.92216 5.42437 6.0404 2.38237 10.0692 2.38237C14.098 2.38237 17.2163 5.42437 17.2163 9.00001ZM18.5398 9.00001C18.5398 13.3857 14.7471 16.9412 10.0692 16.9412C5.39134 16.9412 1.59863 13.3857 1.59863 9.00001C1.59863 4.61437 5.39134 1.05884 10.0692 1.05884C14.7471 1.05884 18.5398 4.61437 18.5398 9.00001ZM10.7352 3.81284L10.7204 11.5422L9.39687 11.5401L9.41169 3.81072L10.7352 3.81284ZM10.7522 13.6059C10.7522 13.4234 10.6797 13.2483 10.5506 13.1192C10.4215 12.9902 10.2465 12.9177 10.0639 12.9177C9.8814 12.9177 9.70634 12.9902 9.57727 13.1192C9.4482 13.2483 9.37569 13.4234 9.37569 13.6059C9.37569 13.7884 9.4482 13.9635 9.57727 14.0926C9.70634 14.2216 9.8814 14.2941 10.0639 14.2941C10.2465 14.2941 10.4215 14.2216 10.5506 14.0926C10.6797 13.9635 10.7522 13.7884 10.7522 13.6059Z"
          fill="#07B9AE"
        />
      </g>
      <defs>
        <clipPath id="clip0_658_11775">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.963379)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ExclamationIcon
